import { PriceCategory, PriceType } from "../test-payloads/graphql";

export const getPriceCategoryFromPriceType = (priceType: PriceType): PriceCategory => {
	const PRICE_TYPE_PERCENTAGE = "_PERCENT";
	const priceTypeValue = priceType.includes(PRICE_TYPE_PERCENTAGE) ? priceType.split(PRICE_TYPE_PERCENTAGE)[0] : priceType;

	switch (priceTypeValue) {
		case PriceType.ExFactoryPrice:
			return PriceCategory.Pexf;
		case PriceType.PublicPrice:
			return PriceCategory.Ppub;
		case "AVG_GENERIC":
			return PriceCategory.AverageGeneric;
		default:
			return priceTypeValue as unknown as PriceCategory;
	}
};
